/*@flow*/
import * as I from 'immutable';

export default (o: any) => I.fromJS(o || {}).hashCode();
